module.exports = __webpack_public_path__ + "img/HoltEstateLogowhite.112949b7.png";